import mvtSearchFilterComponent from '@/common/components/mvtsearchfilter/mvt-searchfilter.js';
import { generateFilterLabel, getIconLabel, getFormatValue } from './generateFilterLabel.js';

/**
 * Generate collapsed filter-chip labels from the external filter model.
 *
 * This is intentionally called with only `filter` (same object as `v-model`),
 * plus `glb` + `molang` so the underlying label functions can use icons and i18n.
 */
export function getLabelsByFilter(filter, { glb, molang } = {}) {
    const safeMolang = typeof molang === 'function' ? molang : (key) => key;
    const context = {
        glb: glb || {},
        molang: safeMolang,
        filter: filter || {},
        modelValue: filter || {},
    };

    // Provide icon/format helpers used by some `searchFilterData[].label` callbacks.
    context.getIconLabel = getIconLabel;
    context.getFormatValue = getFormatValue;

    // Build the same `searchFilterData` the component uses.
    const componentData = typeof mvtSearchFilterComponent.data === 'function' ? mvtSearchFilterComponent.data.call(context) : {};
    context.searchFilterData = componentData?.searchFilterData || [];

    // Build the same `filterModel` getters (no setters needed for read-only label generation).
    context.filterModel = mvtSearchFilterComponent.computed.filterModel.call(context);

    return generateFilterLabel({
        searchFilterData: context.searchFilterData,
        filterModel: context.filterModel,
        filterValue: context.filter,
        isRent: !!mvtSearchFilterComponent.computed.isRent.call(context),
        isSold: !!mvtSearchFilterComponent.computed.isSold.call(context),
    });
}

